export default "__VITE_ASSET__30b3ee87__"